export default __webpack_public_path__ + "static/media/330_dummy2016-kunsthandwerk01-mobile-de.6bfb9c62.png";